const InstaLoader = () => {
  return <span class="backgroundAnimation instaLoader"></span>;
};

export default InstaLoader;
